
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/terms",
      function () {
        return require("private-next-pages/company/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/terms"])
      });
    }
  